<template>
  <div :class="[$style.page, !isNormal && $style.popup]">
    <Title v-if="isNormal" title="DNS设置">
      <template v-slot:actions>
        <Button type="primary2" @click="goBack">返回</Button>
      </template>
    </Title>

    <p :class="$style.top_tip">
      温馨提示：若您的域名已添加解析记录，请勿随意修改解析DNS，否则将导致原解析记录不生效，请谨慎操作!
    </p>

    <Loading :loading="loading">
      <Item v-if="isNormal" title="域名" required>
        <span class="theme-color">{{ name }}</span>
      </Item>

      <Item title="DNS类型" required>
        <el-radio-group v-model="type">
          <el-radio
            v-for="(item, index) in typeList"
            :key="index"
            :label="item.value"
          >
            {{ item.label }}
          </el-radio>
        </el-radio-group>
      </Item>

      <Item :class="$style.record_item" title="DNS记录值" required>
        <template v-if="type === 0">
          <div :class="$style.dns_content">
            <span
              :class="$style.dns_text"
              v-for="(item, index) of dnsList0"
              :key="index"
            >
              <span>DNS{{ index + 1 }}：</span>{{ item }}
            </span>
          </div>
        </template>

        <template v-if="type === 2">
          <div :class="$style.dns_content">
            <span
              :class="$style.dns_text"
              v-for="(item, index) of dnsList1"
              :key="index"
            >
              <span>DNS{{ index + 1 }}：</span>{{ item }}
            </span>
          </div>
        </template>

        <template v-if="type === 1">
          <div :class="$style.dns_content">
            <div
              :class="$style.dns_input"
              v-for="(_, index) of inputList"
              :key="index"
            >
              <span>DNS{{ index + 1 }}：</span>
              <el-input v-model.trim="inputList[index]"></el-input>
            </div>
          </div>
          <div :class="$style.dns_btn">
            <div
              v-if="inputList.length > 1"
              :class="$style.btn"
              @click="handleInputList(false)"
            >
              -
            </div>
            <div
              v-if="inputList.length < 6"
              :class="$style.btn"
              @click="handleInputList(true)"
            >
              +
            </div>
          </div>
        </template>
      </Item>

      <Item title=" ">
        <Button type="primary" @click="submit">确定修改</Button>
      </Item>

      <Item title=" ">
        <el-checkbox v-model="agree">我已阅读并同意</el-checkbox>
        <AgreementPopup :title="agreeTitle" :content="agreeContent" />
      </Item>
    </Loading>

    <template v-if="isNormal">
      <Title title="DNS修改记录" :count="total" />

      <el-table
        :data="showList"
        :fit="true"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column
          prop="createdTime"
          label="修改时间"
          width="120"
          align="center"
        />

        <el-table-column
          prop="oldValue"
          label="原DNS"
          width="120"
          align="center"
        />
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="page"
        :page-size="limit"
        :total="total"
        @current-change="handlePageChange"
      />
    </template>
  </div>
</template>

<script>
import { getDNS, getDNSLog, createDNS } from "@server";
import dnsRules from "@constant/dnsRules";

import AgreementPopup from "@components/AgreementPopup.vue";

export default {
  name: "DomainDNS",
  components: { AgreementPopup },
  props: {
    isNormal: {
      // 普通模式 or 弹窗模式 (default: 普通)
      type: Boolean,
      default: true,
    },
    ids: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      id: "",
      name: "",
      loading: false,

      type: 2,
      typeList: [
        {
          label: "出售页DNS",
          value: 0,
        },
        {
          label: "解析DNS",
          value: 2,
        },
        {
          label: "第三方DNS",
          value: 1,
        },
      ],

      dnsList0: [], // 出售页DNS
      dnsList1: [], // 解析DNS
      inputList: ["", ""], // 第三方DNS

      agree: false,
      agreeTitle: dnsRules.title,
      agreeContent: dnsRules.content,

      page: 1,
      limit: 10,
      showList: [],
      total: 0,
    };
  },
  methods: {
    initPage() {
      if (this.isNormal) {
        const { id = "", name = "" } = this.$route.query;
        this.id = id;
        this.name = name;

        this.getDNSLog();
      }

      this.getDNS();
    },

    goBack() {
      this.$router.push("/user/my-domain");
    },
    //获取DNS
    async getDNS() {
      const params = {};
      this.id && (params.domainId = this.id);

      const res = await getDNS(params);
      const { code, data } = res;

      if (code === 200) {
        const { dnsPlatform, defaultValueList, dnsList } = data;

        this.type = dnsPlatform || 2;
        this.dnsList0 = defaultValueList.find(
          (i) => i.dnsPlatform === 0
        ).values;
        this.dnsList1 = defaultValueList.find(
          (i) => i.dnsPlatform === 2
        ).values;

        switch (dnsPlatform) {
          case 0:
            this.dnsList0 = dnsList;
            break;
          case 2:
            this.dnsList1 = dnsList;
            break;
          case 1:
            for (const idx in dnsList) {
              if (idx < 2) {
                this.inputList[idx] = dnsList[idx];
              } else {
                this.inputList.push(dnsList[idx]);
              }
            }
            break;
        }
      }
    },
    //获取DNS记录
    async getDNSLog(page = 1) {
      this.page = page;
      const params = {
        domainId: this.id,
        page: page,
        limit: this.limit,
      };
      const res = await getDNSLog(params);
      const { code, data } = res;

      if (code === 200) {
        this.showList = data.list;
        this.total = data.total;
      }
    },

    handleInputList(isAdd) {
      isAdd ? this.inputList.push("") : this.inputList.pop();
    },

    async submit() {
      if (!this.agree) {
        this.$message({
          message: `请阅读并同意《${this.agreeTitle}》!`,
          type: "warning",
        });
        return;
      }

      const params = {
        domainIdSet: this.isNormal ? [this.id] : this.ids,
        dnsStation: this.type,
      };

      if (this.type === 1) {
        const dnsList = this.inputList.filter((i) => !!i);

        if (dnsList.length === 0) {
          this.$message({ message: "请至少输入一个DNS", type: "warning" });
          return;
        }

        params.dnsList = dnsList;
      }

      this.$confirm(`确定要修改DNS设置吗？`, "确认修改", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          const res = await createDNS(params);

          if (res.code === 200) {
            if (this.isNormal) {
              this.$message({ message: "修改成功!", type: "success" });
              this.getDNSLog();
            } else {
              this.$emit("success", res.data);
            }
          } else {
            this.$message({ message: res.message, type: "error" });
          }
          this.loading = false;
        })
        .catch(() => {});
    },

    handlePageChange(page) {
      this.getDNSLog(page);
    },
  },
  created() {
    this.initPage();
  },
};
</script>

<style lang='scss' module scoped>
.page {
  min-height: 300px;
  padding: rem(20) rem(50) rem(50);
  background: $white;
  box-shadow: $box-shadow;
  font-size: rem(14);
  color: #333;

  :global {
    ::v-deep .gl-item {
      margin-bottom: rem(30);

      .gl-item__left {
        width: 230px;
        padding-right: rem(40);
        justify-content: flex-end;
      }
    }

    ::v-deep .el-radio {
      .el-radio__label {
        padding-left: $padding-2n;
      }
    }

    .el-pagination {
      margin: rem(50) 0;
      @include flex();
    }
  }

  .top_tip {
    padding: 20px 30px;
    margin-top: rem(20);
    margin-bottom: rem(30);
    background-color: #f4f4f7;
  }

  .record_item {
    align-items: flex-start;

    ::v-deep .dns_content {
      display: flex;
      flex-wrap: wrap;
      row-gap: rem(30);
      max-width: 520px;

      .dns_text {
        min-width: 100px;
        height: 40px;
        line-height: 40px;
        margin-right: 40px;

        > span {
          color: rgb(137, 137, 137);
          white-space: nowrap;
        }
      }

      .dns_input {
        width: 220px;
        margin-right: 40px;
        @include flex();

        > span {
          color: rgb(137, 137, 137);
          white-space: nowrap;
        }
      }
    }

    ::v-deep .dns_btn {
      height: 40px;
      align-self: flex-start;
      @include flex();

      .btn {
        box-sizing: border-box;
        width: 40px;
        height: 40px;
        line-height: 38px;
        font-size: 20px;
        font-weight: bold;
        color: #333;
        text-align: center;
        border: 1px solid rgb(220, 222, 226);
        border-radius: 50%;
        box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
        transition: all 0.2s;
        user-select: none;
        cursor: pointer;

        &:first-child {
          margin-right: 20px;
        }

        &:hover {
          color: $white;
          background: $theme-color;
          border-color: $theme-color;
        }
      }
    }
  }

  /* popup */
  &.popup {
    min-width: 800px;

    padding: 0 rem(10);
    box-shadow: unset;

    :global {
      ::v-deep .gl-item {
        .gl-item__left {
          width: 120px;
        }
      }
    }
  }
}
</style>
